import {createAction, props} from '@ngrx/store';
import {Theme} from '../models/theme.model';
import {NewsletterFormContent, TenantInfo} from '../models/tenant.model';
import {EmailProviderSettings} from '../models/email-provider-settings.model';
import {SupportedLanguage} from '../models/supported-language.model';


export const themeChanged = createAction(
  '[ThemeChanged] Action',
  props<Theme>()
);

export const saveTheme = createAction(
  '[Branding Screen] Save Theme',
  props<Theme>()
);

export const updateStripeStatus = createAction(
  '[Platform API] Update Stripe Status',
  props<{ isConnectedToStripe: boolean }>()
);

export const setTenantInfo = createAction(
  '[Platform Startup] Set Tenant Info',
  props<{ tenantInfo: TenantInfo }>()
);

export const grantFounderPlan = createAction(
  '[User Effects] Grant Founder Plan'
);

export const updateSchoolDetails = createAction(
  '[School Settings Screen] Update School Details',
  props<{ changes: Partial<TenantInfo> }>()
);

export const activatePlatformLifetimePlan = createAction(
  '[Wait For Platform Lifetime Purchase] Activate Platform Lifetime Plan'
);

export const saveNewsletterFormContent = createAction(
  '[Admin Email Marketing] Save Newsletter Form Content',
  props<{ newsletter: NewsletterFormContent }>()
);

export const loadEmailProviderSettings = createAction(
  '[Admin Email Marketing] Load Email Provider Settings'
);


export const emailProviderSettingsLoaded = createAction(
  '[Admin Email Marketing] Email Provider Settings Loaded',
  props<{ emailProviderSettings: EmailProviderSettings }>()
);


export const activateEmailMarketingIntegration = createAction(
  '[Admin Email Marketing] Activate Email Marketing Integration',
  props<{ emailProviderSettings: EmailProviderSettings }>()
);

export const cancelEmailMarketingIntegration = createAction(
  '[Admin Email Marketing] Cancel Email Marketing Integration'
);

export const payPalScriptLoadRequested = createAction(
  '[Paypal Integration] Paypal Script Loaded'
);

export const bulkEmailVerification = createAction(
  '[Tenant Action] bulkEmailVerification',
  props<{ bulkEmailVerificationState: string, bulkEmailSendIdentity?: string }>()
);

export const setSessionLanguage = createAction(
  "[USer Effects] Set Session Language",
  props<{language:SupportedLanguage}>()
);

export const translationsLoaded = createAction(
  "[User Effects] Translations Loaded",
  props<{translations:any}>()
);

export const setTopBanner = createAction(
  "[User Effects] Set Top Banner Presence",
  props<{showTopBanner:boolean}>()
);